<template lang="html">
  <div class="block__content">
    <h2>{{$t('title')}}</h2>
    <template v-if="isInit">
      <div class="text-center loader-wrapper">
        <circle-loader></circle-loader>
      </div>
    </template>
    <template v-else>
      <div>
        <ul class="tarnsfer_form">
          <li>
            <div class="form-step">
              <h2>{{$t('title_1')}}</h2>
              <form class="form" @submit.prevent.stop>
                <payout-form-group :label="$t('Получатель')" :required="true">
                  <div style="width:370px">
                    <PrimeDropdownAccounts :disabled="formDisabled" :accounts="filteredAccounts" v-model="model.values.account"></PrimeDropdownAccounts>
                    <error-message-block v-slot:errors attribute="account" :errors="model.errors"></error-message-block>
                  </div>
                </payout-form-group>
              </form>
            </div>
            <li>
              <div class="form-step">
                <h2>{{$t('title_2')}}</h2>
                <form class="form" @submit.prevent.stop>
                  <payout-form-group :label="$t('Номер карты')" :required="true" :has-errors="model.errors.has('pan')">
                    <payout-masked-input v-model="model.values.pan" mask="DDDD DDDD DDDD DDDD DD" :disabled="formDisabled"></payout-masked-input>
                    <!-- input.form-control(type="text" :disabled="formDisabled" v-model='model.values.pan' v-mask="'#### #### #### #### ##'")-->
                    <error-message-block v-slot:errors attribute="pan" :errors="model.errors"></error-message-block>
                  </payout-form-group>
                  <payout-form-group :label="$t('Сумма')" :required="true" :has-errors="model.errors.has('amount')">
                    <input-amount-currency :disabled="formDisabled" v-model="model.values.amount" currency="RUR"></input-amount-currency>
                    <template v-slot:hints>
                      <payout-input-hint-block :hint="' '">
                        <i18n tag="span" path="amount_hint">
                          <template v-slot:min>{{model.minimum|money('RUR')}}</template>
                          <template v-slot:max>{{model.maximum|money('RUR')}}</template>
                          <template v-slot:cur>RUR</template>
                        </i18n>
                      </payout-input-hint-block>
                    </template>
                    <error-message-block v-slot:errors attribute="amount" :errors="model.errors"></error-message-block>
                  </payout-form-group>
                  <payout-form-group :label="$t('Получаете')">
                    <estimate-qiwi-usd-amount :amount="model.values.amount" v-slot="slotProps">
                      <input-amount-currency :disabled="true" :value="slotProps.result" currency="USD"></input-amount-currency>
                    </estimate-qiwi-usd-amount>
                    <payout-input-hint-block :force-show="true">
                      <div>{{$t('result_amount_hint')}}</div>
                      <div>{{$t('currency_rate_hint')}}</div>
                    </payout-input-hint-block>
                  </payout-form-group>
                </form><br/>
                <div class="text-center">
                  <button class="btn btn-success" :disabled="formDisabled" @click.prevent="submit">{{$t('Перейти к оплате')}}</button>
                </div>
              </div>
            </li>
          </li>
        </ul>
      </div>
    </template>
    <modal class="redirect-modal" :name="modalName" :adaptive="true" width="600px" height="auto" :clickToClose="false">
      <div class="modal-content">
        <div class="modal-inner">
          <h3>{{$t('modal_title')}}</h3>
          <i18n tag="p" path="modal_text">
            <template v-slot:link><a :href="paymentUrl" target="_blank" @click="clickOk">{{$t('modal_link_text')}}</a></template>
          </i18n>
          <div class="buttons">
            <button class="btn btn-success" @click.prevent="clickOk">{{$t('ОК')}}</button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import {Component} from "vue-property-decorator";
import {DepositUsdViaQiwiModel} from "@/views/pages/finance/deposit/usdt/deposit-usd";
import {RemoteRequestState} from "capitalist-shared/src/core/remote";
import PayoutFormGroup from "@/components/forms/payout/PayoutFormGroup.vue";
import CircleLoader from "@/components/loaders/CircleLoader.vue";
import InputAmountCurrency from "@/components/forms/payout/legacy/InputAmountCurrency.vue";
import {MoneyFormatFilter} from "@/models/filters/money";
import PayoutInputHintBlock from "@/components/forms/payout/PayoutInputHintBlock.vue";
import ErrorMessageBlock from "@/components/forms/payout/ErrorMessageBlock.vue";
import { VueMaskDirective } from 'v-mask';
import EstimateQiwiUsdAmount from "@/views/pages/finance/deposit/usdt/EstimateQiwiUsdAmount.vue";
import VModal from "vue-js-modal";
import PayoutMaskedInput from "@/components/forms/payout/forms/inputs/PayoutMaskedInput.vue";
import PrimeDropdownAccounts from "@/components/forms/dropdown/PrimeDropdownAccounts.vue";
Vue.use(VModal);

@Component({
  name: "DepositUsdViaQiwiPage",
  filters: {
    money: MoneyFormatFilter,
  },
  components: {
    PrimeDropdownAccounts,
    PayoutMaskedInput,
    EstimateQiwiUsdAmount,
    ErrorMessageBlock,
    PayoutInputHintBlock,
    InputAmountCurrency, CircleLoader, PayoutFormGroup},
  directives: {
    mask: VueMaskDirective,
  },
})
export default class DepositUsdViaQiwiPage extends Vue {

  model = new DepositUsdViaQiwiModel()

  initStatus = new RemoteRequestState()
  submitStatus = new RemoteRequestState()

  paymentUrl = ''

  get modalName() {
    return 'deposit-usd-via-qiwi-modal-redirect'
  }

  clickOk() {
    this.$modal.hide(this.modalName);
  }

  submit() {
    this.paymentUrl = ''
    this.model.submit().then(({paymentUrl}) => {
      this.paymentUrl = paymentUrl;
      window.open(paymentUrl, 'DepositUsdViaQiwiPage');
      this.$modal.show(this.modalName);
    })
  }

  mounted() {
    this.reloadModel()
  }

  get isInit() {
    return this.model.initStatus.isLoading
  }

  reloadModel() {
    this.model.loadModel().catch(err => {
      this.model.initStatus.loadStart()
      setTimeout(() => {
        this.reloadModel()
      }, 3000)
    })
  }

  get formDisabled() {
    return this.model.initStatus.isLoading
      || this.model.submitStatus.isLoading
  }

  get filteredAccounts() {
    return this.model.accounts
  }

}
</script>

<style scoped lang="less">
.loader-wrapper {
  display: flex;
  justify-content: center;
  margin: 3em 0 1em 0;
}
.modal-inner {
  padding: 50px 50px;
  h3 {
    font-size: 1.5em;
    font-weight: bolder;
    margin: 0 0 1.3em 0;
  }
  .buttons {
    margin-top: 2em;
    align-items: center;
    display: flex;
    justify-content: center;
  }

  a {
    text-decoration: underline;
    font-weight: bolder;
  }
}
</style>

<i18n>
{
  "en": {
    "title": "Deposit USD account via Russian bank cards",
    "title_1": "Account for replenishment",
    "title_2": "Payment requisites",
    "Адрес": "Address",
    "address_hint": "You can choose any of yours address, it will be used for the deposit transaction.",
    "Перейти к оплате": "Proceed to payment",
    "Сумма": "Amount",
    "Получатель": "Beneficiary account",
    "amount_hint": "Amount from {min} to {max} {cur}. The amount must be whole.",
    "Номер карты": "Card number",
    "Получаете": "Result amount",
    "result_amount_hint": "Your account will be replenished with this amount.",
    "modal_title": "Redirecting to payment page...",
    "modal_text": "Please wait while we redirect you to the payment page. If it doesn't open automatically, please click the {link}.",
    "modal_link_text": "link",
    "currency_rate_hint": "In the event of a change in the USD exchange rate, the total amount may be slightly adjusted."
  },
  "ru": {
    "currency_rate_hint": "В случае изменения курса USD итоговая сумма может быть незначительно скорректирована.",
    "modal_text": "Пожалуйста, подождите, идет перенаправление на страницу оплаты. Если страница не открылась автоматически, то перейдите по {link}.",
    "modal_title": "Переход к платежной странице",
    "result_amount_hint": "Эту сумму вы получите на счет.",
    "title": "Пополнение USD счета картами РФ",
    "title_1": "Cчет для пополнения",
    "title_2": "Платежные реквизиты",
    "address_hint": "Можете выбрать любой из ваших адресов, он будет использоваться для транзакции пополнения.",
    "amount_hint": "Сумма от {min} до {max} {cur}. Сумма должна быть целой без копеек.",
    "modal_link_text": "ссылке"
  }
}
</i18n>
